/* eslint-disable eqeqeq */
import ReceiptEditView from '../../../components/pos/receipt_edit'
import apipos from '../../../services/service_pos'
import Swal from 'sweetalert2'

export default {
  components: {
    ReceiptEditView
  },
  data () {
    return {
      search: '',
      currentPage: 1,
      editData: [],
      items_perpage: 10,
      data_list: [],
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: ''
    }
  },
  computed: {
    paginate: function () {
      this.totalItem = this.data_list.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.data_list.slice(index, index + this.items_perpage)
    }
  },
  methods: {
    editReceipt (data) {
      this.$store.commit('Loading')
      var body = {
        'id': data.id
      }
      apipos.billReceiptDetail(this.branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        body,
        result => {
          if (result.response === 'success') {
            this.editData = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลใบเสร็จ',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ระบบมีปัญหา ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    onChange (pageNumber) {
      this.currentPage = pageNumber
    },
    getReceipt () {
      this.$store.commit('Loading')
      let body = {
        'keyword': this.search
      }
      apipos.receiptSearch(this.branch.dyn_address + '/',
        body,
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        result => {
          // console.log(result)
          if (result.response === 'success') {
            this.data_list = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลใบเสร็จ',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    removeBill (val) {
      Swal.fire({
        title: 'ยกเลิกใบเสร็จรับชำระ',
        text: 'ท่านต้องการลบข้อมูล ' + val + ' ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.$store.commit('Loading')
          var body = {
            'doc_no': val
          }
          apipos.receiptDel(this.branch.dyn_address + '/',
            body,
            {
              headers: {
                'Access-Token': this.branch.access_token
              }
            },
            result => {
              if (result.response === 'success') {
                this.getReceipt()
                this.$notification['success']({
                  message: 'ลบข้อมูลเอกสาร' + val + 'สำเร็จ',
                  description:
                    result.message
                })
              } else {
                this.$notification['error']({
                  message: 'ลบข้อมูลเอกสาร' + val + 'ไม่สำเร็จ',
                  description:
                    result.message
                })
              }
              this.$store.commit('Loading')
            },
            error => {
              alert('ระบบมีปัญหา ' + JSON.stringify(error))
              this.$store.commit('Loading')
            }
          )
        }
      })
    },
    printPDF (id) {
      this.$store.commit('Loading')
      var body = {
        'id': id
      }
      apipos.billReceiptDetail(this.branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        body,
        result => {
          if (result.response === 'success') {
            this.form_data = JSON.stringify(result.data)
            setTimeout(() => {
              this.$refs.printReceipt.submit()
            }, 1000)
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลใบเสร็จ',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ระบบมีปัญหา ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    }
  },
  created () {
    this.getReceipt()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/pos/receipt_list.js